/**
 * Displays a number or "-" if the value is 0, null, or undefined
 * @param value - The number to display
 * @returns The number as a string or "-" if 0, null, or undefined
 */
export const displayCountOrDash = (value?: number | null): string =>
  !value || value == null ? "-" : String(value);

export const formatQuantity = (value?: number | null): string | null => {
  if (value == null) return null;
  const n = Number(value);
  if (Number.isNaN(n)) return null;
  return n % 1 === 0 ? String(Math.floor(n)) : String(n);
};
